// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Store from "./store/store"
Vue.prototype.$store = Store


Vue.config.productionTip = false


// import vConsole  from '../src/assets/js/vcconsole'

// 引入base.css与rem.js
import "./assets/js/rem"
import "./assets/css/base.css"
// JsBridge
import bridge from "./assets/js/bridge.js" 
Vue.prototype.$bridge = bridge
//接口Js
import interfaces from "./utils/interfaces"
Vue.prototype.$interfaces =interfaces


//交互工具函数
import Utlis from '../src/utils/utlis'
Vue.prototype.$utlis = Utlis;


//剪切板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)



//vue-touch 插件
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})


Store.dispatch('Token', localStorage.getItem('token'))
Store.dispatch('UserGuid', localStorage.getItem('userguid'))
Store.dispatch(' NickName',localStorage.getItem("nickname"))
Store.dispatch('OtherUserGuid', localStorage.getItem('otheruserguid'))


/* eslint-disable no-new */
new Vue({
  el: '#app',
  Store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js